module.exports = __webpack_public_path__ + "img/lg_ring_0_0_1_null@2x.533a0d55.png";